/* eslint-disable react/prefer-stateless-function */
import React, { Suspense, lazy } from 'react';
import {
  Router, Switch, Route, Redirect
} from 'react-router-dom';
import { history } from './history';
import { connect } from 'react-redux';
import Spinner from './components/@vuexy/spinner/Fallback-spinner';
import { ContextLayout } from './utility/context/Layout';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import SignUp from './views/pages/authentication/login/SignUp';

const ForgotPassword = lazy(() => import('./views/pages/authentication/ForgotPassword'));

const Login = lazy(() => import('./views/pages/authentication/login/Login'));

const Settings = lazy(() => import('./views/Settings'));

const Error404 = lazy(() => import('./views/pages/misc/error/404'));

const Application = lazy(() => import('./views/Application'));

const Calendar = lazy(() => import('./views/pages/calendar/Calendar'));

// const SignUp = lazy(() => import('./views/pages/authentication/login/SignUp'));
// const lockScreen = lazy(() => import("./views/pages/authentication/LockScreen"))
const ResetPassword = lazy(() => import('./views/pages/authentication/ResetPassword'));

// Set Layout and Component Using App Route
const RouteConfig = ({ component: Component, fullLayout, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (window.localStorage.getItem('isUserLogin')
      ? (
        <ContextLayout.Consumer>
          {(context) => {
            const LayoutTag = fullLayout === true
              ? context.fullLayout
              : context.state.activeLayout === 'horizontal'
                ? context.horizontalLayout
                : context.VerticalLayout;
            return (
              <LayoutTag {...props} permission={props.user}>
                <Suspense fallback={<Spinner />}>
                  <Component {...props} />
                </Suspense>
              </LayoutTag>
            );
          }}
        </ContextLayout.Consumer>
      ) : (
        <Redirect to={{
          pathname: '/login',
          state: {
            from: props.location
          }
        }}
        />
      )
    )}
  />
);
const mapStateToProps = (state) => {
  return {
    user: state.auth.login.userRole
  };
};

const AppRoute = connect(mapStateToProps)(RouteConfig);

class AppRouter extends React.Component {
  render() {
    return (
      // Set the directory path if you are deploying in sub-folder
      <Router history={history}>
        <Switch>
          <Route exact path="/" component={Login} fullLayout />
          <Route path="/login" component={Login} fullLayout />
          <Route path="/sign-up" component={SignUp} fullLayout />
          <Route path="/forgot-password" component={ForgotPassword} fullLayout />
          <Route path="/reset-password" component={ResetPassword} fullLayout />
          <AppRoute path="/settings/user" component={Settings} />
          <AppRoute path="/application" component={Application} />
          <AppRoute path="/calendar" component={Calendar} />

          <AppRoute component={Error404} fullLayout={false} />
        </Switch>
        <ToastContainer />
      </Router>
    );
  }
}

export default AppRouter;
